/** Placeholder block while public copy loads. Decorative only. */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden className={`animate-pulse rounded-2xl bg-slate-200 dark:bg-navy-800 ${className}`} />;
}
